module.exports = __webpack_public_path__ + "img/teamviewer-logo.f01e5987.svg";